/**
 * Created by rickborst on 21/08/2017.
 */

import _ from 'lodash';

/**
 * Converts api data to application data.
 *
 * @param {Object} response - Api read data.
 * @param {Object} params - Params object.
 * @returns {Object} Section data.
 */
function convertFromRead (response, params) {
    let rails = _.get(response, ['modules']) || [],
        rows = [],
        channelList = params.channels,
        windowStart = params.start,
        windowEnd = params.end,
        getChannelIdByStringmatch = (rail) => {

            let channelIdByStringmatch = null;

            _.forEach(channelList, (channel) => {
                if (channel.name === rail.title) {
                    channelIdByStringmatch = channel.id;
                }
            });

            return channelIdByStringmatch;
        };

    _.forEach(rails, (rail) => {

        let assets = rail
                ? _.filter(rail.assets, item => {
                    let {start, end} = item,
                        startsWithinWindow = start >= windowStart
                            && start < windowEnd,
                        spansWindow = start < windowStart
                            && end > windowEnd,
                        endsWithinWindow = end >= windowStart
                            && end < windowEnd;

                    return startsWithinWindow
                        || spansWindow
                        || endsWithinWindow;
                })
                : [],
            row = {
                channel: getChannelIdByStringmatch(rail),
                assets: assets
            };

        if (row.channel && row.assets) {
            rows.push(row);
        }
    });

    return {
        start: windowStart,
        end: windowEnd,
        rows
    };
}

export {
    convertFromRead
};


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/epg.js